var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F7F6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5917 135.917C61.4159 137.732 58.5803 138.866 55.6314 138.866C47.8053 138.866 41.3403 132.514 41 124.915L56.0851 115.955L79.5633 126.389L64.5917 135.917Z",
    fill: "#83B8D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5517 97.24L62.323 92.2494C57.3324 89.981 52.5687 88.1663 52.5687 82.6086C52.5687 79.7731 53.4761 78.2986 54.8372 76.7107L78.5423 87.1455L72.6443 90.5481C71.0564 91.5689 69.9222 92.3629 69.9222 93.7239C69.9222 95.1984 71.5101 96.3326 73.5517 97.24Z",
    fill: "#B3D3A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5537 45.5198L73.0981 52.552C72.0773 53.1191 70.7163 54.1399 70.7163 55.7278C70.7163 57.4291 73.325 58.7902 75.7068 59.9244L61.3023 53.5728C57.1057 51.758 52.7957 49.603 52.7957 44.4991C52.7957 42.344 53.3628 40.6427 54.3836 39.1682L85.5745 20C89.3174 22.155 92.9469 26.3516 92.9469 32.1361C92.9469 38.2609 89.7711 42.344 84.5537 45.5198Z",
    fill: "#83B8D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.053 67.9774L106.217 69.5653L82.512 59.1305L110.187 42.4575C113.93 44.6125 117.559 48.8091 117.559 54.5936C117.446 60.7184 114.383 64.915 109.053 67.9774Z",
    fill: "#B3D3A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9774 88.1663L103.042 94.291C108.259 96.6729 109.96 99.395 109.96 102.911C109.96 104.953 108.826 106.881 107.238 108.242L83.6466 97.6937L87.6164 95.4252C91.019 93.6105 92.1532 92.4763 92.1532 91.2286C92.0398 90.0944 91.2459 89.1871 88.9774 88.1663Z",
    fill: "#83B8D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.043 140C108.032 135.35 101.68 132.287 93.9678 128.771L58.1266 112.892C49.0528 108.922 43.1549 103.592 43.1549 94.6313C43.1549 85.8978 47.3515 81.5878 52.9092 78.1851L54.9507 76.9375C53.5897 78.412 52.6823 79.8865 52.6823 82.8354C52.6823 88.3931 57.446 90.2078 62.4366 92.4763L104.062 110.737C111.321 113.8 117.9 119.244 117.9 128.317C117.9 133.308 116.085 137.845 114.043 140Z",
    fill: "#26A135"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.847 106.654L107.238 108.242C108.826 106.881 109.96 104.839 109.96 102.911C109.96 99.3952 108.372 96.6731 103.042 94.2912L58.467 74.6693C49.5066 70.6995 43.8356 65.5956 43.8356 56.6353C43.8356 48.3555 47.9187 43.0247 54.4972 39.0549C53.4764 40.5294 52.9093 42.2307 52.9093 44.3857C52.9093 49.4897 57.1059 51.6447 61.4159 53.4595L104.743 72.6277C112.569 76.1438 119.034 81.3612 119.034 91.002C118.921 98.4878 115.405 103.252 109.847 106.654Z",
    fill: "#006EA6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.9206,
    height: 120,
    fill: "white",
    transform: "translate(41 20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc);
export default __webpack_public_path__ + "static/media/sc.06a80a7e.svg";
export { ForwardRef as ReactComponent };